<template>
  <YTabs v-model="active" v-bind="$attrs">
    <YTabPane v-for="item in tabList" :label="item.name" :key="item.name">
      <div class="content-container">
        <div
          class="group"
          v-for="groupItem in item.groups"
          :key="groupItem.label"
        >
          <div v-if="showGroupName" class="header-row">
            <div class="group-name">
              {{ groupItem.label }}
            </div>
          </div>
          <div class="city-blocks">
            <div
              class="city-block"
              :class="{ active: city._id === activeId }"
              v-for="city in groupItem.list"
              :key="city.name"
              @click="emits('select', unref(city))"
            >
              <span class="city-text">{{ city.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </YTabPane>
  </YTabs>
</template>

<script lang="ts" setup>
import { ref, unref } from "vue";

import YTabPane from "@/components/YTabPane/index.vue";
import YTabs from "@/components/YTabs/index.vue";

import { ICity } from "../types";

interface IProps {
  activeId?: string;
  showGroupName?: boolean;
  tabList: {
    name: string;
    groups: {
      label: string;
      list: ICity[];
    }[];
  }[];
}

const emits = defineEmits(["select"]);
const active = ref(0);
withDefaults(defineProps<IProps>(), {
  tabList: () => [],
  showGroupName: true
});
</script>

<style lang="scss" scoped>
:deep(.el-tabs__nav) {
  width: 100%;
  display: flex;
}

:deep(.el-tabs__item) {
  flex: 1;
  text-align: center;
}
:deep(.el-tabs__nav-wrap::after) {
  background-color: transparent;
}
.content-container {
  flex-grow: 2;
  overflow: auto;
  height: 100%;
  overflow: auto;
}

.header-row {
  margin: 20px 0 0;
  display: flex;
  justify-content: space-between;
}
.group {
  display: flex;
  justify-content: center;
}
.group-name {
  font-size: var(--m-font-size-sm);
  font-family: var(--m-font-family-medium);
}
.city-blocks {
  margin-top: 14px;
  margin-bottom: 24px;
  display: flex;
  flex-flow: row wrap;
  row-gap: 10px;
  column-gap: 10px;
  padding: 0 24px;
}
.city-block {
  height: 38px;
  min-width: 106px;
  font-size: var(--m-font-size-md);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 1px solid #e6e6e6;
  color: #696969;
  background: #ffffff;
  .city-text {
    max-width: 90px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &.active {
    background: var(
      --m-option-location-background-color-active,
      var(--m-option-common-background-color-active)
    );
    border-color: #000;
    color: #333;
    border-width: 1px;
  }
}
</style>
